import { findIndex, mergeDeepRight } from 'ramda';
import { createAction, createLoadConst } from 'util/actions';
import { UPLOAD_FSP_PROFILE } from 'model/export';
import {
  FSPRTN,
  FSP_ON_HOLD_RULES,
  FSP_PAYER_TYPE,
  FSP_PAYNETS_CODE,
  LIMIT_CODE,
  LIMIT_RULE_CODE,
  SSO_URI,
  USER_ROLE_CODE,
  FSP_PROCESSING_FEE,
} from 'consts';

const ARRAY_SECTIONS = [
  FSPRTN,
  FSP_ON_HOLD_RULES,
  FSP_PAYER_TYPE,
  FSP_PAYNETS_CODE,
  LIMIT_CODE,
  LIMIT_RULE_CODE,
  SSO_URI,
  USER_ROLE_CODE,
  FSP_PROCESSING_FEE,
];

export const initialState = {
  fsp: {},
  fspconfig: {},
  fspcoreconfig: {},
  fsponholdrules: [],
  fspotpevent: {},
  fsppalconfig: {},
  fspprocessingfees: [],
  processingfee: {},
  fsppayertype: [],
  fsppaynets: [],
  fsprtn: [],
  limit: [],
  limitrule: [],
  ssouri: [],
  userrole: [],
  fsploanauthopt: [],
  fspConfigKeyValue: [],
};
export const name = 'fspImport';
export const LOAD = createLoadConst(name);
export const load = createAction(LOAD);

export const selector = (state) => state[name];

export default (state = initialState, { data = {}, type }) => {
  switch (type) {
    case LOAD.ACTION: {
      const { key = 'id', section, values } = data;
      if (ARRAY_SECTIONS.includes(section)) {
        const existing = state[section] ?? [];
        const index = findIndex((item) => item[key] === values[key], existing);
        if (index > -1) {
          existing.splice(index, 1, values);
        } else {
          existing.push(values);
        }

        return { ...state, [section]: existing };
      }

      // Special handling for fspConfigKeyValue - merge arrays by configKey
      if (section === 'fspConfigKeyValue' && Array.isArray(values)) {
        const existingValues = state[section] || [];

        const validNewValues = values.filter((item) => item.configKey);

        if (existingValues.length === 0) {
          return validNewValues.length > 0
            ? { ...state, [section]: validNewValues }
            : state;
        }

        const configMap = new Map(
          existingValues.map((item) => [item.configKey, item])
        );

        let hasChanges = false;

        validNewValues.forEach((newItem) => {
          const existing = configMap.get(newItem.configKey);

          const isNew = !existing;
          const valueChanged =
            existing && existing.configValue !== newItem.configValue;
          const typeChanged =
            existing && existing.dataType !== newItem.dataType;

          if (isNew || valueChanged || typeChanged) {
            configMap.set(newItem.configKey, newItem);
            hasChanges = true;
          }
        });

        if (!hasChanges) {
          return state;
        }

        return { ...state, [section]: Array.from(configMap.values()) };
      }
      return { ...state, [section]: mergeDeepRight(state[section], values) };
    }

    case UPLOAD_FSP_PROFILE.ACTION: {
      const {
        fsp,
        fspconfig,
        fspcoreconfig,
        fsponholdrules = [],
        fspotpevent,
        fsppalconfig,
        fsppayertype = [],
        fsppaynets = [],
        fspprocessingfees = [],
        processingfee,
        fsprtn = [],
        limit = [],
        limitrule = [],
        ssouri = [],
        userrole = [],
        fsploanauthopt = [],
        fspConfigKeyValue = [],
      } = data.response ?? {};

      return {
        fsp,
        fspconfig,
        fspcoreconfig,
        fsponholdrules,
        fspotpevent,
        fsppalconfig,
        fsppayertype,
        fsppaynets,
        fspprocessingfees,
        processingfee,
        fsprtn,
        limit,
        limitrule,
        ssouri,
        userrole,
        fsploanauthopt,
        fspConfigKeyValue,
      };
    }

    default:
      return state;
  }
};
